// extracted by mini-css-extract-plugin
export default {"icon":"eventTag_icon__UvJqc","eventTag":"eventTag_eventTag__OV3s9"};